import { render } from "./addRegisterCode.vue?vue&type=template&id=56515dca&scoped=true"
import script from "./addRegisterCode.vue?vue&type=script&lang=js"
export * from "./addRegisterCode.vue?vue&type=script&lang=js"

import "./addRegisterCode.vue?vue&type=style&index=0&id=56515dca&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56515dca"],['__file',"src/views/hostApply/components/addRegisterCode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56515dca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56515dca', __exports__)) {
    console.log('reload')
    api.reload('56515dca', __exports__)
  }
  
  module.hot.accept("./addRegisterCode.vue?vue&type=template&id=56515dca&scoped=true", () => {
    console.log('re-render')
    api.rerender('56515dca', render)
  })

}


export default __exports__